import { createGlobalStyle } from 'styled-components';
import adminBg from '../Assets/bg/adminbg.jpg';

const GlobalStyle = createGlobalStyle`
  body {
    background-color: ${({ darkMode }) => (darkMode ? 'transparent' : '#fff')};
    background-image: ${({ darkMode }) => (darkMode ? `url(${adminBg})` : 'none')};
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    color: ${({ darkMode }) => (darkMode ? '#ffffff' : '#000000')};
    transition: background-color 0.3s ease, color 0.3s ease;
  }

  .dark-mode {
    background-image: (${adminBg});
    color: #fff;
  }

  .dark-mode .table {
    background-color: ${({ darkMode }) => (darkMode ? 'transparent' : '#fff')};
     background-image: ${({ darkMode }) => (darkMode ? `url(${adminBg})` : 'none')};
     background-size: cover;
     background-repeat: no-repeat;
     background-position: center;
    color: #fff;
  }
`;

export default GlobalStyle;
